import type ArticleBodySection from "@/src/_types/Article/article-body-section";
import ReactHtmlParser from "@/src/utils/html-parser";
import RecursiveContent from "@/src/components/journal-site/articles/article-body/article-body-content";
import { Box, Typography } from "@mui/material";
import { HEADING_SIZE } from "@/src/components/common/broadsheet/tokens";

const ArticleBody = ({
  articleBody,
  journalAbbr,
  documentId,
  isDraftEnabled,
  figures,
}: {
  articleBody: ArticleBodySection[] | undefined;
  journalAbbr: string;
  documentId: number;
  isDraftEnabled: boolean;
  figures?: Figure[] | null | undefined;
}) => (
  <Box>
    {articleBody &&
      articleBody.map(
        (section, index) =>
          section.content &&
          section.content.length > 0 && (
            <Box key={index}>
              <Typography
                component="h2"
                sx={{
                  fontSize: HEADING_SIZE.section,
                  marginBlockEnd: "0 !important"
                }}>
                {ReactHtmlParser(section.title)}
              </Typography>
              <RecursiveContent
                content={section.content || {}}
                journalAbbr={journalAbbr}
                documentId={documentId}
                isDraftEnabled={isDraftEnabled}
                figures={figures}
              />
            </Box>
          ),
      )}
  </Box>
);

export default ArticleBody;
